import fetch from 'isomorphic-fetch';
import { parseResponse } from '../core/fetch/response';

export default class MenuItems {
  static constructURL(group) {
    return `${process.env.REACT_APP_CLIENT_CONTENT_API}/menu_items?group=${group}`;
  }

  static async getMenuFooterLeft() {
    const group = 'footer-left';
    const response = await fetch(this.constructURL(group));
    const data = await parseResponse(response);
    return data.data;
  }

  static async getMenuFooterCenter() {
    const group = 'footer-center';
    const response = await fetch(this.constructURL(group));
    const data = await parseResponse(response);
    return data.data;
  }

  static async getMenuFooterRight() {
    const group = 'footer-right';
    const response = await fetch(this.constructURL(group));
    const data = await parseResponse(response);
    return data.data;
  }

  static async get() {
    try {
      const promises = await Promise.all([
        this.getMenuFooterLeft(),
        this.getMenuFooterCenter(),
        this.getMenuFooterRight(),
      ]);
      return promises;
    } catch (err) {
      throw new Error(`Error calling Menu Items API: ${err.message}`);
    }
  }
}
